export { default } from '@shikijs/langs/mermaid'
